import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody42.css';

import clientimg from '../images/case-study-client42.webp'
import outcome from '../images/outcome42.webp'

import sm1 from '../images/cs42so01.webp'
import sm2 from '../images/cs42so02.webp'
import sm3 from '../images/cs42so03.webp'
import sm4 from '../images/cs42so04.webp'


const Casestudybody42 = () => {

    return (
        <>
        <section className='casestudybody42-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A multi-strategy mid-market private equity fund focused on investing in growing companies within fragmented industries</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client sought to raise additional capital for their fund. To secure this investment, the client needed a subsequent closing deck to highlight its unique value proposition and potential for significant returns</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody42-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Onboarding Workshop: </h4>
                          <p>Initiated a kick-off meeting to understand <span style={{color:"#03A393",fontWeight:700}}> client requirements & discussed key considerations </span>while preparing the deck </p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Investment thesis:</h4>
                          <p>Conducted detailed discussions to gain a deep understanding of the <span style={{color:"#03A393",fontWeight:700}}> fund's investment thesis, its core principles</span> and the framework used to identify and evaluate <span style={{color:"#03A393",fontWeight:700}}> priority verticals</span> for investment</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Market Analysis:</h4>
                          <p>Performed an <span style={{color:"#03A393",fontWeight:700}}> in-depth market analysis</span> of the targeted industries to assess <span style={{color:"#03A393",fontWeight:700}}> growth drivers, competitive dynamics</span> and <span style={{color:"#03A393",fontWeight:700}}> emerging trends, </span>enhancing the fund's overall investment narrative</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Portfolio Review & Benchmarking:</h4>
                          <p>Reviewed the fund's existing <span style={{color:"#03A393",fontWeight:700}}> portfolio investments, summarizing high-level financials, growth trajectories</span> and <span style={{color:"#03A393",fontWeight:700}}> forward outlook </span>to contextualize future opportunities and identify synergies</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Investment Rationale:  </h4>
                          <p>Developed a detailed investment rationale anchored in the <span style={{color:"#03A393",fontWeight:700}}> fund's portfolio strengths and strategic priorities, supported</span> by analysis of potential acquisition areas and sector attractiveness</p>
                        </div>
                      </div>     

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Pipeline Overview:</h4>
                          <p>Compiled and assessed a pipeline of potential deals to strengthen the <span style={{color:"#03A393",fontWeight:700}}> fund's opportunity set</span> and illustrate the alignment between thesis focus areas and market availability</p>
                        </div>
                      </div>        

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Stakeholder Review:</h4>
                          <p>Interviewed key stakeholders to seek <span style={{color:"#03A393",fontWeight:700}}> feedback</span> and <span style={{color:"#03A393",fontWeight:700}}> validation,</span> ensuring alignment with the fund's strategic objectives and investment philosophy</p>
                        </div>
                      </div>      

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                       </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody42-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Developed a detailed Subsequent Closing Deck that provided a narrative to increase the investments in the fund. It also included the investment strategy and pipeline opportunities. This deck enabled a better investor understanding and confidence</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody42
